import React from "react";
import LegalPageShell from "./LegalPageShell";

const SUPPORT_EMAIL = "support@vaultgrid.net";

const AccountDeletionPage = () => {
  return (
    <LegalPageShell>
      <h1 className="mb-6 text-center text-2xl font-bold md:text-3xl">
        Delete Your VaultGrid Account
      </h1>

      <p className="mb-4">
        You can delete your VaultGrid account and request deletion of related
        personal data at any time.
      </p>

      <h2 className="mb-3 mt-8 text-xl font-semibold">Delete in the App</h2>
      <ol className="mb-4 list-decimal space-y-2 pl-5">
        <li>Sign in to VaultGrid.</li>
        <li>Open Vault Settings.</li>
        <li>Open Privacy &amp; Security.</li>
        <li>Choose Delete Account and confirm the deletion prompt.</li>
      </ol>

      <p className="mb-4">
        If your account is blocked, choose <strong>Request deletion of my data</strong>
        {" "}on the blocked-account screen. VaultGrid will review the request and
        explain any data it must retain.
      </p>

      <h2 className="mb-3 mt-8 text-xl font-semibold">Request by Email</h2>
      <p className="mb-4">
        If you cannot access the app, email{" "}
        <a className="underline" href={`mailto:${SUPPORT_EMAIL}`}>
          {SUPPORT_EMAIL}
        </a>{" "}
        from the email address linked to your VaultGrid account and include
        "Account deletion request" in the subject.
      </p>

      <h2 className="mb-3 mt-8 text-xl font-semibold">What Happens Next</h2>
      <p className="mb-4">
        We delete or anonymize account data associated with your profile, except
        for limited records we must keep for legal, security, fraud-prevention,
        billing, dispute, or abuse-prevention reasons. More detail is available
        in the Privacy Policy.
      </p>
    </LegalPageShell>
  );
};

export default AccountDeletionPage;
